import { City, Config, User } from "./api";

function body(user: User): boolean {
  return !!user.height;
}

function cityAreas(user: User, city: City | null): boolean {
  return !city?.areas.length || !!user.areas.length;
}

function identity(user: User): boolean {
  return !!user.nationality;
}

function images(user: User): boolean {
  return user.images.length >= 4;
}

function incall(user: User, config: Config): boolean {
  return !config.incalls || !user.incalls.length || !!user.location;
}

function languages(user: User): boolean {
  return !!user.languages.length && user.languages.some((lang) => !!lang.level);
}

function rates(user: User): boolean {
  return !!user.outcalls.length;
}

function services(user: User): boolean {
  return !!user.services.length;
}

function socials(user: User): boolean {
  return !user.independent || user.city?.matured || !!user.socials.length;
}

function verified(user: User): boolean {
  return !user.identity_required || !!user.identity_verified;
}

export const UserValidator = {
  body,
  cityAreas,
  identity,
  images,
  incall,
  languages,
  rates,
  services,
  socials,
  verified,
};
